<table
  class="cx-return-request-items"
  *ngIf="returnRequest$ | async as returnRequest"
>
  <caption class="cx-visually-hidden">
    {{
      'returnRequest.caption' | cxTranslate
    }}
  </caption>
  <thead>
    <tr>
      <th role="columnheader" class="cx-item-list-desc">
        {{ 'returnRequest.item' | cxTranslate }}
      </th>
      <th role="columnheader" class="cx-item-list-price">
        {{ 'returnRequest.itemPrice' | cxTranslate }}
      </th>
      <th role="columnheader" class="cx-item-list-qty">
        {{ 'returnRequest.returnQty' | cxTranslate }}
      </th>
      <th role="columnheader" class="cx-item-list-total">
        {{ 'returnRequest.total' | cxTranslate }}
      </th>
    </tr>
  </thead>

  <tbody class="cx-item-list-items">
    <!-- TODO: This should be a separate component-->
    <tr
      class="cx-item-list-row cx-return-request-item-row"
      *ngFor="let returnEntry of returnRequest.returnEntries; let i = index"
    >
      <td role="cell">
        <!-- Item Image -->
        <div class="cx-table-item-container">
          <cx-media
            [container]="returnEntry.orderEntry?.product.images?.PRIMARY"
            format="thumbnail"
          ></cx-media>
          <!-- Item Description -->
          <div class="cx-info">
            <div *ngIf="returnEntry.orderEntry?.product.name" class="cx-name">
              {{ returnEntry.orderEntry?.product.name }}
            </div>
            <div *ngIf="returnEntry.orderEntry?.product.code" class="cx-code">
              {{ 'cartItems.id' | cxTranslate }}
              {{ returnEntry.orderEntry?.product.code }}
            </div>
            <!-- Variants -->
            <div
              *ngFor="
                let variant of (returnEntry.orderEntry?.product.baseOptions)[0]
                  ?.selected?.variantOptionQualifiers
              "
              class="cx-property"
            >
              <div class="cx-label" *ngIf="variant.name">
                {{ variant.name }}:
              </div>
              <div class="cx-value" *ngIf="variant.value">
                {{ variant.value }}
              </div>
            </div>
          </div>
        </div>
      </td>
      <!-- Item Price -->
      <td
        role="cell"
        class="cx-price"
        *ngIf="returnEntry.orderEntry?.basePrice"
      >
        <div class="cx-mobile-header">
          {{ 'returnRequest.itemPrice' | cxTranslate }}
        </div>
        <div class="cx-value">
          {{ returnEntry.orderEntry?.basePrice?.formattedValue }}
        </div>
      </td>
      <!-- return Quantity -->
      <td role="cell" class="cx-quantity">
        <div class="cx-mobile-header">
          {{ 'returnRequest.returnQty' | cxTranslate }}
        </div>
        <div class="cx-value">
          {{ returnEntry.expectedQuantity }}
        </div>
      </td>
      <!-- Total Price -->
      <td role="cell" class="cx-total">
        <div class="cx-mobile-header">
          {{ 'returnRequest.total' | cxTranslate }}
        </div>
        <div class="cx-value">
          {{ returnEntry.refundAmount?.formattedValue }}
        </div>
      </td>
    </tr>
  </tbody>
</table>
